export default __webpack_public_path__ + "static/media/image-bg.7ce059ec.png";